






















































import { Vue, Component } from 'vue-property-decorator';
import VoteButton from '../components/VoteButton.vue';
import { isWeiXin } from '@/common/ts/common';
import { getDetail, getBaseInfo } from '../api';
import { Button, Swipe, SwipeItem, ImagePreview, Toast, Icon } from 'vant';
Vue.use(Icon);
Vue.use(Button).use(ImagePreview).use(Swipe).use(SwipeItem).use(Toast);
@Component({
  components: {
    VoteButton,
  },
})
export default class Detail extends Vue {
  data: any = {};
  baseInfo: any = {};

  get zanAvaliable() {
    const currentTime = Date.now();
    return currentTime >= Number(this.baseInfo.startTime) * 1000;
  }
  get images() {

    return this.data.cover;
  }
  async created() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    this.getData();
  }
  handlePicShow(index: number) {
    ImagePreview({
      images: this.images,
      startPosition: index,
    });
  }
  async getData() {
    const ret = await getDetail(this.$route.query.id);
    this.data = ret.data;

    // 设置pv和分享
    const cover =
      'https://image2.cqcb.com/d/file/topics/activity/2020-08-27/lk1ixzGG-1598513772461.png';
    this.$appShareInfo({
      title: '大众戏剧创造营第一季',
      url: location.href,
      subtitle: '大众戏剧创造营第一季！',
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '大众戏剧创造营第一季',
        subtitle: '大众戏剧创造营第一季！',
        image: cover,
      });
    }
  }

  updateZan() {
    this.getData();
    this.$emit('updateZan');
  }
}
